document.addEventListener('DOMContentLoaded', () => {
    // Check if the body has the class 'template-product'
    if (document.body.classList.contains('template-product')) {
        const productBlock = document.querySelector('.product-block[data-dynamic-variants-enabled]');

        if (productBlock) {
            // Check if the div has any child elements or text content
            if (!productBlock.innerHTML.trim()) {
                productBlock.classList.add('empty');
                productBlock.style.display = 'none';
            }
        }
    }

    /**************** Search Bar ******************/

    const searchInputs = document.querySelectorAll('header#SiteHeader predictive-search input#Search');
    const closeButtons = document.querySelectorAll('predictive-search .btn--close-search');
    const predictiveScreens = document.querySelectorAll('predictive-search .predictive__screen');
    const predictiveSearches = document.querySelectorAll('#predictive-search');

    // Function to focus on each search input
    function focusInputs() {
        searchInputs.forEach(input => input.focus());
    }
    // Automatically focus all search inputs when the page starts loading
    // focusInputs();

    // Ensure focus remains on all search inputs after the page fully loads
    // window.onload = function () {
    //     focusInputs();
    // };

    // Function to restore the input state for all search inputs
    function restoreInputState() {
        searchInputs.forEach((searchInput, index) => {
            const savedValue = localStorage.getItem(`searchInputValue_${index}`); // Unique key for each input
            if (savedValue !== null) {
                searchInput.value = savedValue;
                searchInput.setAttribute('value', savedValue);

                // Add 'is-active' class if input has a value
                if (searchInput.value.trim() !== '') {
                    searchInput.classList.add('is-active');
                } else {
                    searchInput.classList.remove('is-active');
                }
            }

           // Restore focus to the previously focused input
            const focusedElementId = localStorage.getItem('focusedElementId');
            if (focusedElementId === searchInput.id) {
                // searchInput.focus();
            }
        });
    }

    // Add input event listener to update localStorage and manage classes for all search inputs
    searchInputs.forEach((searchInput, index) => {
        searchInput.addEventListener('input', function () {
            localStorage.setItem(`searchInputValue_${index}`, this.value);

            // Add 'is-active' class if input has a value
            if (this.value.trim() !== '') {
                this.classList.add('is-active');
            } else {
                this.classList.remove('is-active');
            }
        });

        // Save focus state when an input field gains focus
        searchInput.addEventListener('focus', function () {
            localStorage.setItem('focusedElementId', this.id);
        });
    });

    // Function to clear input values and localStorage
    function clearSearchData() {
        searchInputs.forEach((searchInput, index) => {
            searchInput.value = ''; // Clear input value
            searchInput.setAttribute('value', ''); // Clear the value attribute
            searchInput.classList.remove('is-active'); // Remove the 'is-active' class
            localStorage.removeItem(`searchInputValue_${index}`); // Remove only the relevant saved value
        });
        localStorage.clear(); // Clear all items from localStorage
        predictiveSearch.style.display = 'none';
        predictiveSearches.forEach(predictiveSearch => {
            predictiveSearch.style.display = 'none'; // Hide all predictive search containers
        });
    }

    // Add click event listeners to all close buttons
    closeButtons.forEach(closeButton => {
        closeButton.addEventListener('click', clearSearchData);
    });

    // Add click event listeners to all predictive screens
    predictiveScreens.forEach(predictiveScreen => {
        predictiveScreen.addEventListener('click', clearSearchData);
    });

    // Call the restoreInputState function on page load
    window.addEventListener('load', restoreInputState);

    // Re-run restoreInputState function on browser resize
    //window.addEventListener('resize', restoreInputState);


    // Re-run restoreInputState function on scroll to track the active input
    // window.addEventListener('scroll', () => {
    //     const visibleIndex = getVisibleInputIndex(); // Get the currently visible input index
    //     if (visibleIndex !== -1) {
    //         restoreInputState(); // Restore the state for the visible input
    //     }
    // });

});
// document.addEventListener("DOMContentLoaded", function () {
//     setTimeout(() => {
//         // Intentionally broken URL to simulate error
//         fetch("https://invalid-api-url.example.com/json/")
//             .then(response => response.json())
//             .then(data => {
//                 let detectedCountry = data.country_code || "Unknown"; // Get country code
//                 console.log("Detected Country (Real-Time):", detectedCountry);
// // ["CA", "US", "SG", "FR"]
//                 if (["CA"].includes(detectedCountry)) {
//                     let badge = document.createElement("span");
//                     badge.className = "badge";
//                     badge.innerText = "Made in Canada";
//                     document.body.appendChild(badge);
//                 }
//             })
//             .catch(error => console.error("Error fetching country:", error));
//     }, 1000);
// });